module.exports = __webpack_public_path__ + "img/img1.d5e66ff7.png";